import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { usePermissions } from 'src/apps/invest/common/hooks/usePermissions';
import { useSession } from 'src/apps/invest/common/hooks/useSession';
import { PageNotFound } from 'src/apps/invest/common/PageNotFound';
import { ROUTES } from 'src/apps/invest/config';
import { AccountInformationPage } from '../views/InfoPage';

const sessionRedirect = ROUTES.accountInformation;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

type AccountInformationControllerProps = {
  page?: 'main';
};

export const AccountInformationController: React.FC<AccountInformationControllerProps> = ({ page = 'main' }) => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  switch (page) {
    case 'main':
      return <AccountInformationPage />;
    default:
      return <PageNotFound />;
  }
};
